import {Step} from 'react-joyride';
import {tourText} from '../../texts/learnersText';
import {stepConfig} from './learnersStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getLearnersSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Learners');
